/* Karchel — editorial section behaviour.
 *
 * Two independent enhancements, both progressive: with JS off the marquee
 * still scrolls (CSS animation) and the origin section still reads as a
 * plain stack of steps with their own images.
 *
 * Loaded with `defer`, and re-armed on Shopify's theme-editor events so the
 * sections keep working while the merchant edits them.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function onMediaChange(query, handler) {
    if (query.addEventListener) query.addEventListener('change', handler);
    else query.addListener(handler); // Safari < 14
  }

  /* ---------------------------------------------------------------- marquee */

  function initMarquee(root) {
    if (root.dataset.kedReady === 'true') return;
    root.dataset.kedReady = 'true';

    var toggle = root.querySelector('.ked-marquee__toggle');
    var label = toggle && toggle.querySelector('.ked-marquee__toggle-label');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
      var paused = root.dataset.paused === 'true';
      root.dataset.paused = paused ? 'false' : 'true';
      toggle.setAttribute('aria-pressed', String(!paused));
      if (label) label.textContent = paused ? 'Pause' : 'Play';
    });
  }

  /* ----------------------------------------------------------------- origin */

  function initOrigin(root) {
    if (root.dataset.kedReady === 'true') return;
    root.dataset.kedReady = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('.ked-origin__step'));
    var figures = Array.prototype.slice.call(root.querySelectorAll('.ked-origin__figure'));
    if (steps.length === 0 || figures.length === 0) return;

    function activate(index) {
      for (var i = 0; i < figures.length; i++) {
        figures[i].classList.toggle('is-active', i === index);
      }
    }

    activate(0);

    // The pinned column only exists at >=900px; below that each step carries
    // its own inline image and there is nothing to drive.
    var desktop = window.matchMedia('(min-width: 900px)');

    var observer = null;

    function connect() {
      if (observer) return;
      observer = new IntersectionObserver(
        function (entries) {
          // Pick the entry closest to the middle of the viewport rather than
          // the first intersecting one, so fast scrolls land on the right step.
          var best = null;
          var bestDistance = Infinity;
          var mid = window.innerHeight / 2;

          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            var box = entries[i].boundingClientRect;
            var distance = Math.abs(box.top + box.height / 2 - mid);
            if (distance < bestDistance) {
              bestDistance = distance;
              best = entries[i].target;
            }
          }

          if (best) activate(steps.indexOf(best));
        },
        { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );

      for (var i = 0; i < steps.length; i++) observer.observe(steps[i]);
    }

    function disconnect() {
      if (!observer) return;
      observer.disconnect();
      observer = null;
      activate(0);
    }

    // Cross-fading a pinned image is exactly the kind of motion the reduced
    // motion preference is asking us not to do, so it gates the observer on
    // equal footing with the breakpoint. Both are re-evaluated on change:
    // checking reduced motion only once at startup meant a later resize
    // silently reconnected the effect for someone who had opted out.
    function sync() {
      if (desktop.matches && !reduceMotion.matches) connect();
      else disconnect();
    }

    sync();
    onMediaChange(desktop, sync);
    onMediaChange(reduceMotion, sync);
  }

  /* -------------------------------------------------------------- bootstrap */

  function initAll(scope) {
    var context = scope || document;
    var marquees = context.querySelectorAll('.ked-marquee');
    var origins = context.querySelectorAll('.ked-origin');
    for (var i = 0; i < marquees.length; i++) initMarquee(marquees[i]);
    for (var j = 0; j < origins.length; j++) initOrigin(origins[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: sections are replaced wholesale, so re-arm on load/select.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
